/* eslint-disable no-undef */
import { FaFileExcel } from 'react-icons/fa'
import moment from 'moment-timezone'

import FailedOrderTooltip from './FailedOrderCell'

const formatDate = (dateString) => {
  const date = new Date(dateString)
  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0') // +1 because months are 0-indexed
  const year = date.getFullYear()
  return `${year}-${month}-${day}`
}
const getSydneyDate = () => {
  // eslint-disable-next-line no-undef
  return moment().tz('Australia/Sydney')
}
export const columns = [
  {
    Header: () => 'Reference',
    accessor: 'refernece',
    Cell: ({ row }) => <div>{row?.original?.refernece}</div>,
  },
  {
    Header: () => 'Principal',
    accessor: 'principal',
    Cell: ({ row }) => <div>{row?.original?.principal}</div>,
  },
  {
    Header: () => 'Uploaded By',
    accessor: 'uploadedBy',
    Cell: ({ row }) => <div>{row?.original?.uploadedUser}</div>,
  },
  {
    Header: () => 'Uploaded Date & Time',
    accessor: 'uploadedDate',
    Cell: ({ row }) => (
      <div>
        {row?.original?.uploadedDate} {row?.original?.uploadedTime}
      </div>
    ),
  },
  {
    Header: () => 'Carrier',
    accessor: 'carrier',
    Cell: ({ row }) => <div>{row?.original?.carrier}</div>,
  },
  {
    Header: () => 'No. of Orders',
    accessor: 'noOfOrders',
    Cell: ({ row }) => <div>{row?.original?.orderCount}</div>,
  },
  {
    Header: () => 'Status',
    accessor: 'Status',
    Cell: ({ row }) => {
      const setColor =
        row.original.status == 'COMPLETED'
          ? 'green'
          : row.original.status == 'FAILED'
          ? 'red'
          : 'orange'
      return <div style={{ color: setColor }}>{row.original.status}</div> // Set Sydney date to start of the day
    },
  },
  {
    Header: () => 'No. of Failed Orders',
    accessor: 'failedOrderCount',
    Cell: ({ row }) => (
      <FailedOrderTooltip
        content={row.original.failedOrders}
        count={row.original.failedOrderCount}
      />
    ),
  },
  {
    Header: () => 'File',
    accessor: 'uploadedFileUrl',
    Cell: ({ row }) => {
      const fileUrl = row?.original?.uploadedFileUrl

      if (!fileUrl) return null

      return (
        <a href={fileUrl} download target='_blank' rel='noopener noreferrer'>
          <FaFileExcel
            style={{ color: 'green', fontSize: '24px', cursor: 'pointer' }}
          />
        </a>
      )
    },
  },
]
export default columns
